import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=373fb4a3&"
import script from "./teamInfo.vue?vue&type=script&lang=js&"
export * from "./teamInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports